import '../q.css'

import { useEffect, useState } from "react";
import axios from "axios";
import MigationPopup from './Popup/MigationPopup';
import { useNavigate, useParams } from 'react-router-dom';
import SharedRegionProviderOverlay from '../SharedRegionProviderOverlay';
import { TButton, TCopyButton } from '../Key';

const Heading = ({ icon, text }) => {
    return (
        <div className='s-block-heading'>
            {icon} {text}
        </div>
    )
}

const Button = ({ text, onClick, disabled = false }) => {
    return (<button className='t-copy-btn' disabled={disabled} onClick={onClick}>
        {text}
    </button>)
}

const CopyButton = ({ copyValue, text, activeText = "✅ Скопировано" }) => {

    const [isCopied, setCopied] = useState(false);

    const copyToClipboard = (event) => {
        event.preventDefault();
        navigator.clipboard.writeText(copyValue);
        setCopied(true);
    }

    useEffect(() => {
        if (isCopied) {
            setTimeout(() => {
                setCopied(false);
            }, 3500)
        }
    }, [isCopied])

    return (<Button onClick={copyToClipboard} text={isCopied ? activeText : text} />)
}

export { Button, Heading, CopyButton };

export default function KeyVless() {

    const { id } = useParams();

    const [pageState, setPageState] = useState('search');
    const [userKeyID, setUserKeyID] = useState('');
    const [prolongationDays, setProlongationDays] = useState(0);
    const [isCreatingBackupKey, setCreatingBackupKey] = useState(false);
    const [isDeletingBackupKey, setDeletingBackupKey] = useState(false);


    const [isProviderAndRegionOverlayOpened, setProviderAndRegionOverlayOpened] = useState(false);
    const [databaseRegion, setDatabaseRegion] = useState(null);
    const [databaseProvider, setDatabaseProvider] = useState(null);

    // States and updates
    const [isMigrationOverlayOpened, setMigrationOverlayOpened] = useState(false);
    const [isArchieveingKey, setArchieveingKey] = useState(false);
    const [archieveSafetyCounter, setArchieveSafetyCounter] = useState(0);

    const [isProlongationOverlayOpened, setProlongationOverlayOpened] = useState(false);
    const [isProlongationLoading, setProlongationLoading] = useState(false);
    const [databaseKey, setDatabaseKey] = useState(null);

    const [migrationHistory, setMigrationHistory] = useState([]);

    const navigate = useNavigate();

    useEffect(() => {
        if (id !== undefined && id !== null && id !== '') {
            setUserKeyID(id);
        }
    }, [id]);

    const getPlan = (plan) => {
        const n = parseInt(plan);
        if (n === 0) {
            return 'Базовый';
        }
        if (n === 1) {
            return 'Премиум';
        }
        if (n === 2) {
            return 'Deeplink';
        }
        if (n === 3) {
            return 'Семейный 6м';
        }
        if (n === 15) {
            return 'Семейный год';
        }
        if (n === 4) {
            return 'Базовый 🇬🇧';
        }
        if (n === 5) {
            return 'Базовый 🇫🇮';
        }
        if (n === 6) {
            return 'Базовый 🇩🇪';
        }
        if (n === 10) {
            return 'Базовый 🇺🇸';
        }
        if (n === 7) {
            return 'Базовый Yota';
        }
        if (n === 11) {
            return 'Семейный Yota';
        }
        if (n === 8) {
            return 'Семейный 🇬🇧';
        }
        if (n === 9) {
            return 'Семейный 🇫🇮';
        }
        if (n === 13) {
            return 'Семейный 🇩🇪';
        }
        if (n === 14) {
            return 'Семейный 🇺🇸';
        }
        if (n === 12) {
            return 'Russia';
        }
        if (n === 99) {
            return 'Триальный';
        }

        if (n === 20) {
            return 'Я в Китае';
        }
        if (n === 21) {
            return 'Я в Китае / 6м';
        }

        return '';
    };

    const formatDate = (dateObject) => {
        return ("0" + dateObject.getDate()).slice(-2) + "." +
            ("0" + (dateObject.getMonth() + 1)).slice(-2) + "." +
            dateObject.getFullYear();
    }


    // Supported on vless: ✅
    const archieveKey = async () => {
        if (isArchieveingKey) { return }
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        try {
            setArchieveingKey(true)
            const req = await axios.post("https://ger.wa.48.defaultbot.com/v4/archive-user-key/vless", { id: userKeyID }, { headers: { Authorization: `Bearer ${token}` } });
            if (req.data.ok) {
                await searchKey();
            } else {
                alert('Something went wrong');
            }
            setArchieveingKey(false);
            setArchieveSafetyCounter(0);
        } catch (e) {
            console.log(e);
            alert("Something went wrong");
        }
    }

    const clearInformation = () => {
        window.location = '/key';
    }

    useEffect(() => {
        if (archieveSafetyCounter === 5) {
            archieveKey();
        }
    }, [archieveSafetyCounter])

    useEffect(() => {
        if (id !== null && id !== undefined) {
            if (id.length > 0) {
                searchKeyByID(id)
            }
        }
    }, [id])


    // Supported on vless: ✅
    const searchKey = async () => {
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        console.log({ userKeyID })
        const request = await axios.post('https://ger.wa.48.defaultbot.com/v4/get-user-key/vless', { id: userKeyID }, { headers: { Authorization: `Bearer ${token}` } });
        const { data } = request;
        const { key } = data;
        console.log({ data })
        if (key !== null) {
            setDatabaseKey(key);
            setPageState('response');


            setDatabaseProvider(data.regionAndProvider.provider);
            setDatabaseRegion(data.regionAndProvider.region);
        }

        if (data.history) {
            console.log({ history: data.history })
            setMigrationHistory(data.history)
        }
    }

    // Supported on vless: ✅
    const searchKeyByID = async (localeID) => {
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        const request = await axios.post('https://ger.wa.48.defaultbot.com/v4/get-user-key/vless', { id: localeID }, { headers: { Authorization: `Bearer ${token}` } });
        const { data } = request;
        const { key } = data;

        if (data.ok === false) {
            alert("Key is not found");
            navigate('/vless-key')
            return;
        }

        console.log({ data })
        setDatabaseKey(key);
        setPageState('response');


        setDatabaseProvider(data.regionAndProvider.provider);
        setDatabaseRegion(data.regionAndProvider.region);

        if (data.history) {
            console.log({ history: data.history })
            setMigrationHistory(data.history)
        }
    }
    const shortenIdForMobile = (processingId) => {
        const id = String(processingId);
        const idStart = id.slice(0, 4);
        const idInBetween = '...';
        const idEnd = id.slice(id.length - 4, id.length);
        return `${idStart}${idInBetween}${idEnd}`;
    }


    const deleteOutlineKey = async () => {
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        // deleteOutlineKey
        const data = {
            key: databaseKey.id,
        };
        console.log({ data });
        try {
            setDeletingBackupKey(true);
            const req = await axios.post('https://ger.wa.48.defaultbot.com/v4/deleteVlessKey', data, { headers: { Authorization: `Bearer ${token}` } });
            if (req.data.ok) {
                searchKey();
            } else {
                alert('Something went wrong');
            }
            setDeletingBackupKey(false);
        } catch (e) {
            console.log({ e });
        }
    }

    const makeOutlineBackupKey = async () => {
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        const data = {
            key: databaseKey.id,
        };
        console.log({ data });
        try {
            setCreatingBackupKey(true);
            const req = await axios.post('https://ger.wa.48.defaultbot.com/v4/backupVlessKey', data, { headers: { Authorization: `Bearer ${token}` } });
            if (req.data.ok) {
                searchKey();
            } else {
                alert('Something went wrong');
            }
            setCreatingBackupKey(false);
        } catch (e) {
            console.log({ e });
        }
    };

    // Supported on vless: ✅
    const prolongateKey = async () => {
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        setProlongationLoading(true);
        const data = {
            key: databaseKey.id,
            days: prolongationDays,
        };

        try {
            const req = await axios.post("https://ger.wa.48.defaultbot.com/v4/prolongateKey/vless", data, { headers: { Authorization: `Bearer ${token}` } });
            if (req.data.ok) {
                await searchKey();
            } else {
                alert('Something went wrong');
            }
            setProlongationDays(0);
            setProlongationLoading(false);
            setProlongationOverlayOpened(false);
        } catch (e) {
            console.log(e);
            alert("Something went wrong");
        }
    }


    const validateUserKey = (event) => {
        if (event.target.value === '') {
            return;
        }
        let key = String(event.target.value);
        let keyId = '';

        if (String(key).includes('?q=')) {
            const array = key.split('?q=');
            key = array[0];
        }

        // https://bot.simplesmm.org/ea1994d2-981e-4542-a592-9f318eb809cc?q=Базовый
        if (String(key).includes('https://bot.simplesmm.org/')) {
            const validKey = String(key);
            keyId = validKey.split('https://bot.simplesmm.org/')[1];
            setUserKeyID(keyId);
        }
    };

    const getCurrentServerSafe = (dbKey) => {
        if (dbKey === null || dbKey === undefined) {
            return "";
        }

        if (dbKey.configuration == null || dbKey.configuration === undefined) {
            return "";
        }

        try {
            return JSON.stringify(atob(dbKey.configuration)).split("@")[1].split("?")[0]
        } catch (e) {
            console.log(e);
            return "";
        }
    }


    const configurationEndpointURLs = {
        default: databaseKey === null ? "" : "https://config.x.simplesmm.org/" + databaseKey.id + "#SimpleVPN / " + getPlan(databaseKey.plan),
        mirror: databaseKey === null ? "" : "https://conf.simpletg.org/" + databaseKey.id + "#SimpleVPN / " + getPlan(databaseKey.plan)
    }

    if (pageState === 'response') {
        return (
            <>

                {isMigrationOverlayOpened && <MigationPopup
                    migrationHistory={migrationHistory}
                    plan={databaseKey.plan}
                    databaseRegion={databaseRegion}
                    databaseProvider={databaseProvider}
                    currentSni={databaseKey.sni ?? ""}
                    keyID={databaseKey.id}
                    close={() => setMigrationOverlayOpened(false)}
                    currentServer={databaseKey.comment}
                    currentConfiguration={getCurrentServerSafe(databaseKey)}
                    reload={() => {
                        searchKey();
                        setMigrationOverlayOpened(false);
                    }} />}

                {isProviderAndRegionOverlayOpened && <>
                    <SharedRegionProviderOverlay
                        chat_id={databaseKey.user_id}
                        region={databaseRegion}
                        setRegion={setDatabaseRegion}
                        provider={databaseProvider}
                        setProvider={setDatabaseProvider}
                        close={() => {
                            setProviderAndRegionOverlayOpened(false);
                            searchKey();
                        }}
                    />
                </>}

                {isProlongationOverlayOpened && (<div className='overlay'>
                    <div className='overlay-content'>
                        <div>Продляем ключ на количество дней</div>
                        <input type='number' className='t-input' value={prolongationDays} min={0} onChange={e => setProlongationDays(e.target.value)} placeholder='На сколько дней?'></input>
                        <button className='t-button' disabled={isProlongationLoading} onClick={prolongateKey}>{isProlongationLoading ? '⏳ Изменяем ход времени...' : "Продлить"}</button>
                        <button className='t-button' onClick={() => setProlongationOverlayOpened(false)}>Закрыть</button>
                    </div>
                </div>)}
                <div className="content-block t-container">
                    <div className="page-header">
                        <div></div>
                        <button className='t-close-page-btn' onClick={() => { navigate('/') }}>
                            ❌
                        </button>
                    </div>
                    <div className="t-updated-content" style={{ paddingBottom: '120px' }}>
                        <Heading icon={'🧍🏻'} text={'Пользователь'} />
                        <div className='t-data-double' onClick={() => navigate('/user/' + databaseKey.user_id)}>
                            <div className='t-data-block pointer'>@{databaseKey.username}</div>
                            <div className='t-data-block pointer'>{databaseKey.user_id}</div>
                        </div>
                        <div className='t-data-double'>
                            <div className='t-data-block'>{databaseRegion !== '' ? databaseRegion : "Регион не установлен"}</div>
                            <div className='t-data-block'>{databaseProvider !== '' ? databaseProvider : "Провайдер не установлен"}</div>
                        </div>
                        <TButton disabled={false} onClick={() => {
                            setProviderAndRegionOverlayOpened(true)
                        }} text={"⚙️ Регион / Оператор"} />
                        <Heading icon={'🔑'} text={"Ключ " + shortenIdForMobile(databaseKey.id)} />
                        {databaseKey.is_active === false && <span className='t-data-block error'>Ключ не активен</span>}
                        <div className='t-data-double'>
                            <div className='t-data-block small'><b>{"Vless"} / {getPlan(databaseKey.plan)}</b></div>
                            <div className='t-data-block small'>{getPlan(databaseKey.plan)}</div>
                        </div>
                        <div className='t-data-double'>
                            <TCopyButton text={'✏️ Ссылка'} copyValue={`https://shared.simplesmm.org/${databaseKey.id}?q=${getPlan(databaseKey.plan)}`} />
                            <TCopyButton text={'🪞 Ссылка'} copyValue={`https://key.simpletg.org/${databaseKey.id}?q=${getPlan(databaseKey.plan)}`} />
                        </div>
                        <div className='t-data-double'>
                            <TCopyButton text={'✏️ Конфигурация'} copyValue={"`" + configurationEndpointURLs.default + "`"} />
                            <TCopyButton text={'🪞 Конфигурация'} copyValue={"`" + configurationEndpointURLs.mirror + "`"} />
                        </div>
                        <div className='t-data-double'>
                            {
                                databaseKey.configuration_backup_text === null &&
                                <TButton text={!isCreatingBackupKey ? "🪨 Создать статику" : "⏳ Создаем ключ..."} disabled={isCreatingBackupKey} onClick={makeOutlineBackupKey} />}
                            {<TButton
                                disabled={isArchieveingKey}
                                onClick={() => {
                                    if (archieveSafetyCounter === 5) {
                                        return;
                                    }
                                    setArchieveSafetyCounter(archieveSafetyCounter + 1);
                                }}
                                text={isArchieveingKey ? "⏳ Архивируем ключ..." : archieveSafetyCounter === 0 ? "⚠️ Архивировать ключ" : `🚨 Нажмите ${5 - archieveSafetyCounter} раз`} />}

                        </div>


                        {databaseKey.configuration.length === 0 && <span className='t-data-block error'>Сломанный конфиг, мигрируй ключ!</span>}

                        {databaseKey.configuration_backup_text !== null && <>
                            <Heading icon={'🛠️'} text={'Статический ключ ( Старая версия )'} />
                            <div className='t-data-double'>
                                <TCopyButton text={'Ссылка'} copyValue={databaseKey.configuration_backup_text} />
                                <TButton text={isDeletingBackupKey ? "⏳ Удаляем..." : "Удалить статический ключ"} disabled={isDeletingBackupKey} onClick={deleteOutlineKey} />
                            </div>
                        </>}

                        <Heading icon={'⏰'} text={'Время действия'} />
                        <div className='t-data-double'>
                            <div className='t-data-block'>{formatDate(new Date(databaseKey.expire_date))}</div>
                            <TButton disabled={false} text={"Продлить"} onClick={() => setProlongationOverlayOpened(true)} />
                        </div>


                        <Heading icon={'🕸️'} text={'Сервер'} />
                        <div className='t-data-block' >{(databaseKey.comment ?? "")}</div>
                        <div className='t-data-double'>
                            <div className='t-data-block'><div>{databaseKey.vless_url !== undefined && databaseKey.vless_url !== null && <>{new URL(databaseKey.vless_url).host.split(":")[0]}</>}</div></div>
                            {databaseKey.sni !== undefined && databaseKey !== null && <div className='t-data-block'>{databaseKey.sni}</div>}
                        </div>

                        {databaseKey.configuration === undefined || databaseKey.configuration === null && <div className='t-data-block'>{databaseKey.key_url !== undefined && databaseKey.key_url !== null ? databaseKey.key_url : '⚠️ Deleted Server'}</div>}
                        <TButton onClick={() => setMigrationOverlayOpened(true)} text={"Миграция"} />
                        {migrationHistory.length > 0 && <div style={{ paddingBottom: '120px' }}>
                            <Heading icon={'📜'} text={'История Миграций'} />
                            <div className='migrations-list'>
                                {migrationHistory.map((historyItem) => {
                                    return <div className='t-data-block migration-item'><span style={{ color: "rgba(255, 255, 255, 0.5)", fontSize: '14px' }}>{new Date(historyItem.created_at).toLocaleString()}</span><br /> {historyItem.from_server_comment} → {historyItem.to_server_comment}</div>
                                })}
                            </div>
                        </div>}
                    </div>
                </div></>)
    }

    if (pageState === 'search') {
        return <>
            <div className="content-block t-container">
                <div className="t-content split">
                    <div className="page-header">
                        <h1>Ключ Vless</h1>
                    </div>
                    <input
                        value={userKeyID}
                        placeholder="https://bot.simplesmm.org/XXXX"
                        onChange={validateUserKey}
                        type="text"
                        className="t-input"
                    ></input>
                    <button
                        className="t-button"
                        onClick={(e) => {
                            e.preventDefault();
                            searchKey();
                        }}
                    >
                        Найти ключ
                    </button>
                </div>
            </div>
        </>
    }

}
